export default __webpack_public_path__ + "static/media/screen9.b3133eef.jpg";